import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './shared/components/not_found/not_found.component';
import { AppDefaultGuard } from './app.default_guard';
import { PRODUCT_CHOOSE_PATH } from './install/shared/navigation/constants';
import { ProductComponent } from './signup/product/product.component';
import { ProductGuard } from './signup/product/signup.product_guard';

const mainRoutes: Routes = [
  {
    path: PRODUCT_CHOOSE_PATH,
    component: ProductComponent,
    canActivate: [ProductGuard],
  },
  { path: '',
    pathMatch: 'full',
    component: AppDefaultGuard,
    canActivate: [AppDefaultGuard], children: [] },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(mainRoutes, {useHash: true})
  ],
  exports: [
    RouterModule
  ],
  providers: [AppDefaultGuard]
})
export class AppRoutingModule {}
